/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authManageNotifications'

type $nsid = typeof $nsid

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'app.bsky.notification.getPreferences',
        'app.bsky.notification.getUnreadCount',
        'app.bsky.notification.listActivitySubscriptions',
        'app.bsky.notification.listNotifications',
        'app.bsky.notification.putActivitySubscription',
        'app.bsky.notification.putPreferences',
        'app.bsky.notification.putPreferencesV2',
        'app.bsky.notification.registerPush',
        'app.bsky.notification.unregisterPush',
        'app.bsky.notification.updateSeen',
      ],
    }),
  ],
  {
    title: 'Manage Bluesky Notifications',
    'title:lang': {},
    detail: 'View and configure notifications for the Bluesky app.',
    'detail:lang': {},
  },
)

export { main }
